
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Gallery from './components/Gallery';
import Pricing from './components/Pricing';
import Team from './components/Team';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import PromoBanner from './components/PromoBanner';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <PromoBanner />
      <Navigation />
      <Hero />
      <Services />
      <About />
      <Gallery />
      <Pricing />
      <Team />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
